// 创建文件en/index.js
const Vietnamese = {
    rejected: "Đã từ chối",
    my: "Của tôi",
    today: "Hôm nay",
    this_week: "Tuần này",
    this_month: "Tháng này",
    last_month: "Tháng trước",
    this_year: "Năm nay",
    number_of_people: "Số người",
    amount: "Số tiền",
    enter_username_id_to_search: "Nhập tên người dùng ID để tìm kiếm",
    team_list: "Danh sách nhóm",
    registration_time: "Thời gian đăng ký",
    selling_face_value: "Giá trị mặt hàng bán",
    click_for_details: "Nhấp để xem chi tiết",
    "agent_login": "Đăng nhập đại lý",
    'SignOut': "Hủy tài khoản",
    'Contact us': "Liên hệ chúng tôi",
    'Download our app': "Tải ứng dụng của chúng tôi",
    'Download it from': "Đường dẫn tải xuống",
    'About Us': "Về chúng tôi",
    'Gobuy USA was founded in 2012': "Gobuy Mỹ được thành lập vào năm 2012",
    'Customer service': "Dịch vụ khách hàng",
    'frequently asked question': "Câu hỏi thường gặp",
    'Return and exchange policy': "Chính sách hoàn trả và đổi hàng",
    'Shipping and distribution': "Vận chuyển và giao hàng",
    'Contact us by email': "Thông qua email liên hệ chúng tôi",
    'Privacy Policy and Terms of Use': "Chính sách bảo mật và Điều khoản sử dụng",
    'Privacy Policy': "Chính sách bảo mật",
    'Terms of use': "Điều khoản sử dụng",
    'Upload credentials': "Nộp bằng chứng",
    'The withdrawal is being processed': "Đang xử lý rút tiền",
    'Cause of failure': "Nguyên nhân thất bại",
    'Your shopping cart is still empty': "Giỏ hàng của bạn vẫn đang trống",
    'Log in to view the items in your cart': "Đăng nhập để xem sản phẩm trong giỏ hàng",
    'Browse around': "Xem qua",
    'Account correlation': "Tài khoản liên quan",
    'Order management': "Quản lý đơn hàng",
    'Payment method': "Phương thức thanh toán",
    'Collection address': "Địa chỉ nhận tiền",
    Category: "Phân loại",
    "MyCommission": "Hoa hồng của tôi",
    "Gross income": "Tổng doanh thu",
    "Direct commission": "Hoa hồng trực tiếp",
    "Indirect commission": "Hoa hồng gián tiếp",
    "Transfer to wallet": "Chuyển vào ví",
    "Tip: The transfer amount must be greater than 10USDT": "Lưu ý: Số tiền chuyển khoản phải lớn hơn 10 USDT",
    "transfer": "Chuyển khoản",
    "commission": "Hoa hồng",
    "Please enter": "Vui lòng nhập",
    'Old Password': "Mật khẩu cũ",
    'Change password': "Đổi mật khẩu",
    'Amazon GIFT CARD': "Thẻ quà tặng Amazon",
    'High Priced Recycling': "Thu mua giá cao",
    'Data': "Ngày",
    'congratulations': "Chúc mừng",
    'Obtain': "đạt được",
    'ThankYouForParticipating': "Cảm ơn đã tham gia",

    // navbar"",
    Home: "Trang chủ",
    Search: "Tìm kiếm",
    ShoppingCart: "Giỏ hàng",
    Mine: "của tôi",

    // 首页
    // 搜索
    EnterSearchContent: "Nhập nội dung tìm kiếm",
    'Recent searches': "Tìm kiếm gần đây",
    'popular searches': "Tìm kiếm phổ biến",
    'Please search': "Vui lòng nhập từ khóa bạn muốn tìm kiếm",
    'orderSearch': "Nhập tên đơn hàng hoặc sản phẩm để tìm kiếm",

    // 语言
    'Language selection': "Chọn ngôn ngữ",

    // menu
    Brand: "Thương hiệu",
    Collect: "Thu thập",
    Manage: "Quản lý",
    Order: "Đơn hàng",
    Wallet: "Ví tiền",
    BlindBox: "Hộp bí ẩn",
    MenuGiftCard: "Thẻ quà tặng",
    // HotSale
    HotSale: "Tin tức mới nhất đang bán chạy...",
    // tabs"",
    TodaysOffer: "Khuyến mãi hôm nay",
    'Phone': "Điện thoại di động",
    'Smart Watch': "Đồng hồ thông minh",
    'Smart bracelet': "Vòng đeo tay thông minh",

    // gobuy
    'home.gobuy.title': "Sự bất ngờ đang chờ đón bạn",
    'home.gobuy.periods': "Vòng quay quà bí ẩn",
    'home.gobuy.freeze': "Tham gia đếm ngược",
    'home.gobuy.drawing': "Bắt đầu đếm ngược",
    'home.gobuy.buy': "Tham gia",
    'home.gobuy.isbuy': "Đã tham gia",
    USDT: "USDT",
    'home.gobuy.jackpot': "Quỹ thưởng",
    Purse: "Ví tiền",
    Box: "Hộp bí ẩn",
    'GetAPrize': "Nhận giải thưởng",
    Discount: "Giảm giá",
    when: "Khi nào",
    points: "Điểm tích lũy",
    seconds: "giây",
    // MessageBox
    'MessageBox.Tips': "Thông báo",
    'MessageBox.Confirm': "Xác nhận",
    'MessageBox.Cancel': "Hủy bỏ",
    'MessageBox.buy.box': "Bạn có chắc chắn muốn mua hộp quà bí ẩn này không?",
    // Toast
    'succ': "Thành công",
    'err': "Lỗi",
    'box.succeeds': "Mua hàng thành công",
    'box.frozen': "Đã tham gia",
    'box.issue': "Mỗi kỳ chỉ được mua một hộp blind box",

    // 商品列表
    filter: "Lọc",
    sales: "Doanh số bán hàng",
    selfOP: "Tự doanh",
    noMore: "Không còn nữa",
    brand: "Thương hiệu",
    confirm: "Xác nhận",
    reset: "Đặt lại",
    ComSor: "Xếp hạng tổng hợp",
    MostPop: "Phổ biến nhất",
    HighLow: "Giá từ cao đến thấp",
    LowHigh: "Giá từ thấp đến cao",
    SalVol: "Số lượng bán được",
    NewArr: "Mới lên kệ",

    // 购物车
    'cart.cart': "Giỏ hàng",
    'cart.edit': "Biên tập",
    'cart.done': "Hoàn thành",
    'home.cart.voucher': "Nhận phiếu giảm giá",
    'home.cart.outstock': "Hết hàng",
    'home.cart.offshelf': "Hạ kệ",
    'Only': "Chỉ còn",
    'left': "Một",
    'Promotion': "Khuyến mãi",
    'cart.all': "Chọn tất cả",
    'cart.total': "Tổng cộng",
    'cart.delete': "Xóa",
    'cart.checkout': "Thanh toán",

    // 我的
    'Direct': "Trực tiếp",
    'Indirect': "Gián tiếp",
    'MyOrders': "Đơn hàng của tôi",
    'ViewAll': "Xem tất cả",
    'Unpaid': "Chưa thanh toán",
    'ToShip': "Chưa giao hàng",
    'ToReceive': "Chờ nhận hàng",
    'ToReview': "Đang chờ đánh giá",
    // 盲盒
    'MyBlindBox': "Danh sách hộp mù",
    'WaitingDraw': "Chờ quay số",
    'Opened': "Đã mở (nhận/trả lại)",
    // 礼品卡
    'After sale': "BẢO HÀNH",
    'GiftCard': "Lịch sử thu hồi",
    'RecycleGiftCard': "Thẻ quà tặng thu hồi",
    'Verifying': "Kiểm tra",
    'Rebuying': "Đang mua lại",
    'Repurchased': "Chưa chuyển khoản",
    'Paid': "Đã chuyển khoản",
    // 常用工具
    'CommonTools': "Công cụ thường dùng",
    'MyWallet': "Ví tiền của tôi",
    'VirtualOrders': "Đơn hàng ảo",
    'Refunds': "Hoàn tiền",
    'MyFriends': "我的朋友",
    'ChatList': "Danh sách trò chuyện",
    'RealNameVerification': "Xác thực danh tính",
    'MyFavorites': "Bộ sưu tập của tôi",
    'Addresses': "Quản lý địa chỉ",
    'MyReviews': "Ý kiến của tôi",
    'BrowsingHistory': "Lịch sử duyệt web",
    'Promotions': "Khuyến mãi",
    'StoreManagement': "Quản lý cửa hàng",
    'BecomeASeller': "Trở thành người bán",

    // 订单列表
    'SearchPlaceholder': "Nhập tên sản phẩm đặt hàng để tìm kiếm",
    All: "Tất cả",
    OrderNo: "Số đơn hàng",
    items: "vụ việc",
    ShippingFee: "Phí vận chuyển",
    'Refund in Progress': "Đang hoàn trả tiền",
    'Cancel Order': "Hủy đơn hàng",
    'Refund': "Hoàn tiền",
    'Track Shipping': "Kiểm tra vận chuyển",
    'Confirm Receipt': "Xác nhận nhận hàng",
    'Evaluate': "Đánh giá",
    'Delete': "Xóa",
    'Pay': "Thanh toán",
    'MessageBox.delete.order': "Bạn có chắc chắn muốn xóa đơn hàng này không?",
    'MessageBox.cancel.order': "Bạn có chắc chắn muốn hủy đơn hàng này không?",
    'MessageBox.receive.order': "Đơn hàng này có được giao nhận chưa?",
    // 订单详情
    'Order Details': "Đơn hàng chi tiết",
    'Pickup Code': "Mã vận chuyển",
    'Complaint': "Phàn nàn",
    'After-Sales': "BẢO HÀNH",
    'Gift': "Quà tặng",
    'Order Date': "Ngày đặt hàng",
    'Used voucher worth': "Số tiền của phiếu giảm giá đã sử dụng",
    'CNY': "Nhân dân tệ",
    'Payment Method': "Phương thức thanh toán",
    'Total Product Amount': "Tổng số tiền hàng hóa",
    'Shipping Fee': "Phí vận chuyển",
    'Amount Paid': "Số tiền đã thanh toán",
    'Return': "Trả lại hàng",
    // 盲盒列表
    'Pending Draw': "Đang chờ trúng thưởng",
    'Pending Unboxing': "Chưa mở",
    'Unboxed': "Đã bật",
    'Collected': "Đã nhận",
    'Recycled': "Đã thu hồi",
    'Unknown': "Không rõ",
    'Claim': "Nhận",
    'Recycle': "Giải quyết",
    'Unbox': "Bật",
    'MessageBox.recycle.box': "Bạn có chắc chắn muốn thu hồi hộp quà bí ẩn này không?",
    // 盲盒详情
    'Mystery Box Details': "Chi tiết hộp quà bí ẩn",
    'Unopened': "Chưa bật",
    'box.opened': "Chưa bật",
    'Claimed': "Đã nhận",
    'Confirm Claim': "Xác nhận nhận",
    'MessageBox.pick.box': "Bạn có chắc chắn muốn mở hộp quà bí ẩn này không?",
    // 盲盒提货
    'Please add address': "Vui lòng thêm địa chỉ",
    // 礼品卡列表
    'Face Value Total': "Giá trị mệnh giá",
    // 礼品卡详情
    'Gift Card Details': "Chi tiết thẻ quà tặng",
    'Card number': "Số tài khoản",
    'Activation code': "Mã kích hoạt",
    'Actual recovery price': "Giá trị thu hồi thực tế",
    // 礼品卡回收
    'Gift Card Recycling': "Thẻ quà tặng thu hồi",
    'Confirm Recycling': "Xác nhận thu hồi",
    'Please enter the card number': "Vui lòng nhập số thẻ",
    'Please enter the activation code': "Vui lòng nhập mã kích hoạt",
    'MessageBox.recycle.gift': "Bạn có chắc chắn muốn thu hồi thẻ quà tặng này không?",

    // 我的钱包
    'My Wallet': "Ví tiền của tôi",
    'Available Balance': "Số dư khả dụng",
    'Frozen Funds': "Đóng băng tiền",
    'Recharge': "Nạp tiền",
    'Withdraw': "Rút tiền",
    "can": "Có thể",
    'Withdrawal Accounts': "Tài khoản rút tiền",
    // 充值
    'Recharge Details': "Chi tiết nạp tiền",
    'Recharge Order No.': "Mã số đơn hàng nạp tiền",
    'Recharge Amount': "Số tiền nạp",
    'Creation Time': "Thời gian tạo",
    'MessageBox.recharge.pop': "Vui lòng nhập số tiền nạp",
    // 付款
    'payment': "Thanh toán",
    'Order submitted successfully, please select payment method': "Đơn hàng được gửi thành công, vui lòng chọn phương thức thanh toán",
    'Rechargeable card': "Thẻ nạp tiền",
    'Please enter a hash': "Nhập mã băm",
    'Immediate payment': "Thanh toán ngay",
    'Wait for the file to load': "Vui lòng chờ đợi file tải lên",
    // 提现
    'Withdrawal Details': "Chi tiết rút tiền",
    'Withdrawal Amount': "Số tiền rút",
    'Application Time': "Thời gian nộp đơn",
    'New Application': "Mới nộp đơn",
    'Payment Password': "Mật khẩu thanh toán",
    'New Payment Password': "Mật khẩu thanh toán mới",
    'Recipient Information': "Thông tin người nhận",
    'Submit': "Nộp",
    'Add Recipient Account First': "Vui lòng thêm tài khoản nhận tiền trước",
    'Please bind your mobile phone or email first': "Vui lòng liên kết số điện thoại hoặc email của bạn trước",
    // 设置
    'Account Settings': "Cài đặt tài khoản",
    'Change Login Password': "Sửa đổi mật khẩu đăng nhập",
    'Change Payment Password': "Sửa đổi mật khẩu thanh toán",
    'Log Out': "Đăng xuất",
    'Mobile': "Điện thoại di động",
    'Verification Code': "Mã xác minh",
    'Email': "Hộp thư điện tử",
    'New Password': "Mật khẩu mới",
    'Confirm Password': "Xác nhận mật khẩu",
    'Modify': "Sửa đổi",
    'Bind': "liên kết",
    ' Mobile': "Điện thoại di động",
    ' Email': "Hộp thư điện tử",
    // 资金详情
    'Fund Details': "Chi tiết tài chính",
    'Withdrawal Account': "Tài khoản rút tiền",
    'Account Type': "Loại tài khoản",
    'USDT Address (TRC20)': "Địa chỉ USDT (TRC20)",
    'Edit': "Biên tập",
    'Delete': "Xóa",
    'Add New': "Thêm tài khoản mới",
    'MessageBox.delete.bank': "Bạn có chắc chắn muốn xóa tài khoản rút tiền này không?",
    // 登录
    'Login': "Đăng nhập",
    'Sign Up': "Đăng ký",
    'Normal Login': "Đăng nhập thông thường",
    'Username / Email / Phone Number': "Tên người dùng/email",
    'Enter Phone Number': "Vui lòng nhập số điện thoại",
    'Enter Email': "Vui lòng nhập địa chỉ email",
    'Enter SMS Code': "Vui lòng nhập mã xác minh tin nhắn",
    'Enter Password': "Vui lòng nhập mật khẩu",
    "enter_login_password_for_verification": "Vui lòng nhập mật khẩu đăng nhập để xác thực",
    'Forgot Password': "Quên mật khẩu",
    'Third-party Login': "Đăng nhập bên thứ ba",
    'Please complete the form': "Vui lòng điền đầy đủ vào mẫu",
    'WeChat': "WeChat",
    'Weibo': "Weibo",
    'QQ': "QQ",
    'phone login': "Đăng nhập bằng điện thoại",
    'Login Expired': "Đăng nhập đã hết hạn",
    'Please enter your phone number first': "Vui lòng nhập số điện thoại trước",
    'Please enter your username/email/phone number': "Vui lòng nhập tên người dùng/email",
    'Please enter your password': "Vui lòng nhập mật khẩu",
    'Password must be at least 6 characters': "Mật khẩu phải có ít nhất 6 ký tự",
    'Please enter an 11-digit phone number': "Vui lòng nhập số điện thoại 11 chữ số",
    'Please wait for the file to finish loading': "Vui lòng chờ đợi việc tải tệp hoàn tất",
    'send': "Gửi",
    'signUpTips': "Dữ liệu cá nhân của bạn sẽ được sử dụng để hỗ trợ trải nghiệm của bạn trên toàn bộ trang web, quản lý quyền truy cập vào tài khoản của bạn và các mục đích khác được mô tả trong chính sách bảo mật của chúng tôi.",

    // 注册
    'Sign Up': "Đăng ký",
    'Referrer': "Người giới thiệu",
    'Invitation code': "Mã mời",
    'Invite friends': "Mời bạn bè",
    'Username': "Tên người dùng",
    'Full Name': "Tên thật",
    'Set Password': "Thiết lập mật khẩu",
    'Confirm Password': "Xác nhận mật khẩu",
    'Phone Number': "Số điện thoại di động",
    'Email': "Thư điện tử",
    'Username: 3-25 chars, letters & numbers': "Tên người dùng: 3-25 ký tự, chữ cái và số",
    '6-20 digits/letters/symbols': "Số/chữ/ký tự từ 6 đến 20",
    'By clicking sign up, you agree to': "Nhấn đăng ký có nghĩa là bạn đồng ý",
    'User Agreement': "Thỏa thuận người dùng",
    'Please check the user agreement': "Vui lòng kiểm tra thỏa thuận người dùng",
    'Please enter a username with 3-25 characters': "Vui lòng nhập tên người dùng từ 3 đến 25 ký tự",
    'Enter SMS Verification Code': "Vui lòng nhập mã xác minh tin nhắn",
    'Please enter your phone number': "Vui lòng nhập số điện thoại của bạn",
    'Please enter the verification code': "Vui lòng nhập mã xác minh",
    'Please enter a 6-digit verification code': "Vui lòng nhập mã xác minh 6 chữ số",
    'Please enter a password with 6-20 characters': "Vui lòng nhập mật khẩu từ 6 đến 20 ký tự",
    'Please enter the confirm password': "Vui lòng nhập lại mật khẩu",
    'The confirm password does not match the entered password': "Mật khẩu xác nhận không khớp với mật khẩu nhập",

    // 密码恢复
    'Password Recovery': "Khôi phục mật khẩu",
    'Forgot Password': "Quên mật khẩu",
    'Forget.email.tips': "Nếu tài khoản của bạn chưa được liên kết với số điện thoại, vui lòng liên hệ quản trị viên nền tảng để khôi phục mật khẩu.",

    // 通知
    'Notification Message': "Thông báo",
    'Direct Message': "Tin nhắn riêng tư",
    'System Message': "Thông báo hệ thống",
    'Leave a Message': "Nhắn tin",

    // 配送地址
    'Delivery Address': "Địa chỉ giao hàng",
    'The store is no longer valid, please edit the delivery address again': "Cửa hàng này không còn hiệu lực, vui lòng chỉnh sửa lại địa chỉ giao hàng",
    'Default address': "Địa chỉ mặc định",
    'Add address': "Thêm địa chỉ",
    'Edit address': "Địa chỉ chỉnh sửa",
    'MessageBox.delete.address': "Bạn có chắc chắn muốn xóa địa chỉ này không?",
    'name': "Tên",
    'phone': "Số điện thoại",
    'district': "khu vực",
    'address': "Địa chỉ",
    'default address': "Địa chỉ mặc định",
    'save and use': "Lưu và sử dụng",
    'save': "Lưu trữ",
    'Please select a region': "Vui lòng chọn khu vực",
    'Please fill in the recipient name': "Vui lòng nhập tên người nhận",
    'Name must be 2-15 characters': "Tên phải có từ 2 đến 15 ký tự",
    'Please fill in the mobile phone number': "Vui lòng nhập số điện thoại",
    'Please select your location': "Vui lòng chọn vị trí của bạn",
    'Please fill in the detailed address': "Vui lòng điền địa chỉ đầy đủ",

    // 浏览历史
    'Browsing History': "Lịch sử duyệt web",
    'Clear browsing history': "Xóa lịch sử duyệt web",

    // 推广会员
    'Promotion member': "Khuyến mãi thành viên",
    "“PromotionPoster”": "Poster quảng cáo",
    "MemberName": "Tên thành viên",
    "MyAssets": "Translated Text: Tài sản của tôi",
    "DistributedAmount": "Số tiền được phân bổ",
    "NumberOfDistributedProducts": "Phân bổ số lượng sản phẩm",
    "DistributedProductAmount": "Số tiền được phân bổ",
    "MyTeam": "Đội của tôi",
    "LevelOneMembers": "Thành viên cấp một",
    "LevelTwoMembers": "Thành viên cấp hai",
    "PromotionPoster": "Poster quảng cáo",
    "PromotionMembers": "Thành viên quảng bá",
    "PromotionPerformance": "Hiệu suất quảng bá",
    "ViewPromotionLink": "Nhấp để xem liên kết quảng cáo",
    "PromoteViaWeChatQRCode": "Qua mã QR WeChat quảng bá",
    "Copy": "Sao chép",
    "BrowserNotSupportedCopyManually": "Trình duyệt của bạn không hỗ trợ sao chép trực tiếp, vui lòng sao chép thủ công",
    "GiftCardRecoveryTotal": "Tổng số thẻ quà tặng được thu hồi",
    "TodaysGiftCardRecoveryCount": "Số lượng thẻ quà tặng thu hồi hôm nay",
    "RegistrationDate": "Ngày đăng ký",
    "LastLogin": "Cuối cùng đăng nhập",
    "Promotion Commission": "Hoa hồng quảng cáo",

    // userinfo 个人信息
    "Personal Info": "Thông tin cá nhân",
    "Nickname": "Tên gọi khác",
    "Birthdate": "Ngày sinh",
    "Save": "Lưu trữ",
    "CropImage": "Cắt ảnh",
    "UseImage": "Sử dụng hình ảnh",

    // goodsDetail 商品详情
    "Off": "Giảm giá",
    "Sold": "Đã bán",
    "Product": "Sản phẩm",
    "Comment": "Bình luận",
    "Details": "Chi tiết",
    "ReportViolation": "Báo cáo",
    "Cart": "Giỏ hàng",
    "ChatMessages": "Tin nhắn trò chuyện",
    "MyShop": "Cửa hàng của tôi",
    "MerchantLogin": "Người bán đăng nhập",
    "Share": "Chia sẻ",
    "ShareTo": "Chia sẻ đến",
    "WeChat": "WeChat",
    "Copy": "Sao chép",
    "Poster": "Poster",
    "BrowserNotSupportedCopyManually": "Trình duyệt của bạn không hỗ trợ sao chép trực tiếp, vui lòng sao chép thủ công",
    "Follow": "Quan tâm",
    "Unfollow": "Hủy theo dõi",
    "PleaseSelectQuantityAndCategory": "Vui lòng chọn số lượng và loại.",
    "SelectedWithQuantity1": "Đã chọn {specification}, số lượng {number}.",
    "SelectedQuantity1": "Số lượng đã chọn {số}.",
    "SelectedWithQuantity2": "Đã chọn {specification}, số lượng {number}.",
    "Add to cart": "Thêm vào giỏ hàng",
    "Buy now": "Mua ngay",
    "Stock": "Kho hàng",
    "Pieces": "vụ việc",
    "Quantity": "Số lượng",
    "All": "Tất cả",
    "Good": "Đánh giá tốt",
    "Medium": "Trung bình",
    "Bad": "Đánh giá tiêu cực",
    // 评论
    "Product review": "Đánh giá sản phẩm",
    "anonymous": "Vô danh",
    "noReviewInfo": "Không có thông tin nhận xét",
    "Shop Owners Response": "Phản hồi của chủ shop",
    "This product has no current reviews": "Hiện tại sản phẩm này chưa có nhận xét nào",
    "Product details": "Sản phẩm chi tiết",
    "shop": "Cửa hàng",
    "customerService": "Dịch vụ khách hàng",
    "shoppingCart": "Giỏ hàng",
    "addToCart": "Thêm vào giỏ hàng",
    "buyNow": "Mua ngay",
    "outOfStock": "Sản phẩm đã chọn hiện không có hàng, xin lỗi!",
    "notAvailable": "Sản phẩm được chọn không còn được cung cấp, xin lỗi!",
    "Store order message": "Cửa hàng thông báo đặt hàng",
    "Confirm the order": "Xác nhận đơn hàng",
    "productAmount": "Số tiền sản phẩm",
    "discount": "Giảm giá",
    "shippingFee": "Phí vận chuyển",
    "subtotal": "Tổng cộng cửa hàng",
    "Submit an order": "Gửi đơn hàng",
    // 退货
    "refundAdd": "Thêm tiền hoàn trả",
    "back": "Trở lại",
    "refundDescription": "Hủy hoàn tiền:",
    "proofOfRefund": "Hóa đơn hoàn tiền",
    "use": "Sử dụng",
}
export default Vietnamese
